import { Typography } from '@mui/material';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import { FormattedMessage } from 'react-intl';

export function DemandMonitoringCategoryInfoContent() {
  return (
    <div>
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>
      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="demand.info.why.useful.description"
      />
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>
      <InfoContentItem titleId="demand.info.ordGmv7d.title" descriptionId="demand.info.ordGmv7d.description" />
      <InfoContentItem titleId="demand.info.ordQty7d.title" descriptionId="demand.info.ordQty7d.description" />
      <InfoContentItem titleId="demand.info.last.wow.title" descriptionId="demand.info.last.wow.description" />
      <InfoContentItem titleId="demand.info.ord.itm.avg.title" descriptionId="demand.info.ord.itm.avg.description" />
      <InfoContentItem titleId="demand.info.trend.title" descriptionId="demand.info.trend.description" />
      <InfoContentItem titleId="demand.info.growth.gap.title" descriptionId="demand.info.growth.gap.description" />
      <InfoContentItem
        titleId="demand.info.relevant.products.title"
        descriptionId="demand.info.relevant.products.description"
      />
    </div>
  );
}
